import { useContext, useState } from 'react'
import Radio from '../../../../Components/Radio/Radio'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import ImageLayout from '../../Layouts/ImageLayout/ImageLayout'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import './WifiCoverageView.css'

const WifiCoverageView = () =>
{
    let context = useContext(ConfiguratorContext)

    let [state, setState] = useState(context.wifiCoverageCheck)

    context.validateWifiCoverage = () =>
    {
        context.wifiCoverageCheck = state
        return true
    }

    return (
        <ImageLayout src="../assets/wi-fi.png">
            <div className="wifi-coverage-container">
                <div className="wifi-coverage-title">
                    Sei interessato ad una consulenza per la verifica della copertura wi-fi nella tua abitazione?
                </div>
                <div className="wifi-coverage-choices">
                    <Radio title="SI" onChange={() => setState(true)} checked={state}></Radio>
                    <Radio title='NO' onChange={() => setState(false)} checked={!state}></Radio>
                </div>
            </div>
        </ImageLayout>
    )
}

const WifiCoverageNode: NavigationNode = {
    content: () => <WifiCoverageView />,
    next: (_: Configuration) => ViewType.enterEmail,
    previous: (context: Configuration) => ViewType.homeUse,
    percentage: 36
}

export default WifiCoverageNode